import src from "IMAGE";
export default { src, width: 288, height: 288, blurWidth: 0, blurHeight: 0};
